// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 108 ? "__federation_expose_UserEventsPanel" : chunkId) + "." + {"27":"7abbe89361794503","108":"9bca34aef4b9fb90","195":"7abbe89361794503","259":"7abbe89361794503","536":"8784fa44fce453ed"}[chunkId] + ".css";
};